module.exports = __webpack_public_path__ + "img/trash-bin.b8d41c65.svg";